// extracted by mini-css-extract-plugin
module.exports = {"patientName":"Table_patientName__2Tg1Z","productName":"Table_productName__1YciU"};